<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <page-header class="py-4 pb-6">
      {{ $t('TaxType') }}
      <template #subtitle>
        {{ $t('TaxTypeConfigMenu') }}
      </template>
    </page-header>
    <loading-provider :loading="loading">
      <div
        style="
      display: grid;
      grid-gap: 16px;
      grid-auto-rows:360px ;
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
"
      >
        <v-card
          v-for="(item,index) in taxList"
          :key="item.id"
          class="text-body-1 mt-4 px-6 py-4"
          elevation="0"
          @click="editItem(item,index)"
        >
          <div
            class="fill-height d-flex flex-column"
            style="border-radius: 16px"
          >
            <div class="d-flex justify-space-between align-center py-4">
              <div
                class="text-h3 font-weight-bold"
              >
                {{ item?._langsname }}
              </div>
            </div>
            <v-spacer />
            <div class="py-4">
              <v-card
                v-for="i in item.taxList.slice(0,2)"
                :key="i.id"
                class="px-4 py-2 mt-4"
                color="grey lighten-5"
                elevation="0"
              >
                <div class="text-right d-flex align-center">
                  <div class="text-body-1">
                    {{ i.consumeTypeName }}
                  </div>
                  <v-spacer />
                  <div>
                    {{ (i.taxRateValue * 100).toFixed(2) }}%
                  </div>
                </div>
              </v-card>
            </div>
            <div class="my-4">
              <v-card
                class="px-4 py-4"
                color="grey lighten-4"
                elevation="0"
                @click.stop="settingTax(item)"
              >
                <div class="text-right d-flex align-center">
                  <div class="text-body-1">
                    {{ $t('TaxSettings') }}
                  </div>
                  <v-spacer />
                  <v-icon
                    class="mt-1"
                    size="18"
                  >
                    mdi-chevron-right
                  </v-icon>
                </div>
              </v-card>
            </div>
          </div>
        </v-card>
      </div>
    </loading-provider>
    <ik-entity-form
      v-model="showTaxDialog"
      :edited-index="taxIndex"
      :model="model"
      :title="$t('menu')"
      @need-refresh="reload"
    />
    <v-dialog
      v-model="taxSettingDialog"
      max-width="600"
      persistent
    >
      <v-card
        class="pa-8"
      >
        <loading-provider :loading="loading">
          <div class="d-flex align-center">
            <div class="text-h3">
              {{ $t('TaxType') }}: <span class="font-weight-bold">{{ taxItem?._langsname }}</span>
            </div>
            <v-spacer />
            <div>
              <v-btn
                icon
                @click="taxSettingDialog = false"
              >
                <v-icon large>
                  mdi-close
                </v-icon>
              </v-btn>
            </div>
          </div>
          <div class="mt-8">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <div
                class="d-flex align-center justify-center my-4"
              >
                <div
                  class="text-h5 font-weight-bold"
                >
                  {{ $t('InHouse') }}
                </div>
                <v-spacer />
                <v-text-field
                  v-model="IHTaxRate"
                  :rules="rules"
                  dense
                  hide-details
                  outlined
                  style="max-width: 200px"
                  suffix="%"
                  type="number"
                />
              </div>
              <div
                class="d-flex align-center justify-center my-4"
              >
                <div
                  class="text-h5 font-weight-bold"
                >
                  {{ $t('takeaway') }}
                </div>
                <v-spacer />
                <v-text-field
                  v-model="togoTaxRate"
                  :rules="rules"
                  dense
                  hide-details
                  outlined
                  style="max-width: 200px"
                  suffix="%"
                  type="number"
                />
              </div>
            </v-form>
          </div>
          <div
            class="d-flex justify-center align-center mt-8"
          >
            <v-btn
              :disabled="!valid"
              class="amber lighten-4 flex-grow-1 mr-4"
              large
              outlined
              @click="saveAll"
            >
              {{ $t('save') }}
            </v-btn>
            <v-btn
              class="blue lighten-4 flex-grow-1"
              large
              outlined
              @click="taxSettingDialog = false"
            >
              {{ $t('cancel') }}
            </v-btn>
          </div>
        </loading-provider>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import CategoryType from '@/model/dataLayer/api/dish/CategoryType'
import Tax from '@/model/dataLayer/api/export/Tax'
import pageHeader from '@/views/widget/typography/PageHeader'
import LoadingProvider from '@/views/widget/LoadingProvider'
import IkEntityForm from '@/plugins/EntityFrameWork/IkEntityForm.vue'

export default {
  components: {
    LoadingProvider,
    pageHeader,
    IkEntityForm
  },
  data: function () {
    return ({
      togoTaxRate: '',
      IHTaxRate: '',
      tax: [],
      rules: [
        v => !!v || this.$t('TaxIsRequired')
      ],
      valid: true,
      loading: false,
      taxSettingList: [],
      taxSettingDialog: false,
      taxItem: [],
      taxIndex: null,
      showTaxDialog: false,
      taxList: [],
      model: CategoryType
    })
  },
  mounted () {
    this.reload()
  },
  methods: {
    async getRealTaxListById (id) {
      this.taxSettingList = this.tax.filter(it => it.dishesCategoryTypeId === id)
    },
    async saveAll () {
      this.loading = true
      for (const item of this.taxSettingList) {
        if (item.consumeTypeId === 2) {
          item.taxRateValue = this.togoTaxRate / 100
        } else {
          item.taxRateValue = this.IHTaxRate / 100
        }
        await Tax.edit(item)
      }
      this.loading = false
      this.taxSettingDialog = false
      await this.reload()
    },
    async settingTax (item) {
      this.taxSettingDialog = true
      this.loading = true
      this.IHTaxRate = (item.taxList.find(it => it.consumeTypeId === 1).taxRateValue * 100).toFixed(2)
      this.togoTaxRate = (item.taxList.find(it => it.consumeTypeId === 2).taxRateValue * 100).toFixed(2)
      this.taxItem = item
      this.taxSettingList = (await Tax.getList(true)).filter(it => it.dishesCategoryTypeId === item.id)
      this.loading = false
    },
    async editItem (item, index) {
      this.taxItem = item
      this.taxIndex = index
      this.showTaxDialog = true
    },
    async reload () {
      this.loading = true
      this.tax = (await Tax.getList(true))
      this.taxList = (await CategoryType.getList(true))
      this.taxList.forEach(item => {
        item.taxList = this.tax.filter(it => it.dishesCategoryTypeId === item.id)
      })
      console.log(this.taxList, 'list')
      this.loading = false
    }
  }
}
</script>
